import { isRouteErrorResponse, useLocation, useNavigate, useRouteError } from 'react-router';
import { Card } from '../components/ui/Card.tsx';
import { ErrorState } from '../components/ui/States.tsx';
import { errorMessage } from '../lib/api.ts';
import { useDocumentTitle } from '../lib/hooks.ts';

function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && /dynamically imported module|Importing a module script failed|error loading dynamically|Failed to fetch/i.test(error.message);
}

/** Per-route error boundary: the shell stays usable and only the page area shows the error. */
export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const location = useLocation();
  useDocumentTitle('เกิดข้อผิดพลาด');

  if (import.meta.env.DEV) console.error(error);

  const chunk = isChunkLoadError(error);
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  const title = notFound ? 'ไม่พบหน้าที่ต้องการ' : chunk ? 'โหลดหน้านี้ไม่สำเร็จ' : 'หน้านี้เกิดข้อผิดพลาด';
  const message = notFound
    ? 'ลิงก์อาจไม่ถูกต้องหรือหน้านี้ถูกย้ายแล้ว'
    : chunk
      ? 'อาจมีการอัปเดตระบบหรือการเชื่อมต่อขาดหาย กรุณาลองใหม่'
      : errorMessage(error);

  return (
    <div className="route-error">
      <Card>
        <ErrorState
          title={title}
          message={message}
          onRetry={() => {
            if (chunk) window.location.reload();
            else navigate(location.pathname + location.search, { replace: true });
          }}
        />
      </Card>
    </div>
  );
}
